import Vue from 'vue';
import { getters } from '@/modules/core/app/helpers/store';

Vue.prototype.$isClustersSupportEnabled = () =>
  getters.session.getUserSettings().isClustersSupportEnabled;
